import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Plane, LogOut, User } from "lucide-react";

export default function PublicNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="as-glass sticky top-0 z-40" data-testid="public-nav">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <Plane size={18} className="as-gold" strokeWidth={1.5} />
          <span className="as-serif text-xl tracking-tight">AeroSphere <span className="as-gold">Global</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-9 text-sm text-[#756E64]">
          <Link to="/charter" className="hover:text-[#1A1D24] transition-colors" data-testid="nav-charter">Charter</Link>
          <Link to="/fleet" className="hover:text-[#1A1D24] transition-colors" data-testid="nav-fleet">Fleet</Link>
          <a href="/#services" className="hover:text-[#1A1D24] transition-colors" data-testid="nav-services">Services</a>
          <a href="/#story" className="hover:text-[#1A1D24] transition-colors" data-testid="nav-story">Our Standard</a>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to="/dashboard" className="text-sm text-[#1A1D24] flex items-center gap-2" data-testid="nav-dashboard">
                <User size={14} /> {user.name?.split(" ")[0]}
              </Link>
              <button onClick={async () => { await logout(); nav("/"); }} className="as-btn-ghost text-xs px-3 py-2 rounded-sm flex items-center gap-1" data-testid="nav-logout">
                <LogOut size={13} /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm text-[#756E64] hover:text-[#1A1D24]" data-testid="nav-login">Sign In</Link>
              <Link to="/charter/inquiry" className="as-btn-gold text-xs px-4 py-2.5 rounded-sm as-mono uppercase tracking-widest" data-testid="nav-request-quote">
                Request Quote
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
